import React from "react";
import classnames from "classnames";
import { GeneralIcon, type GeneralIcons } from "modules/common/components/planr/icon/Generalcon";
import styles from "./TabBar.module.scss";

export interface TabBarItem {
    key: string;
    label: string;
    icon: GeneralIcons;
    /** Счётчик ожидающих действий; 0 или не задан — не показывается */
    badge?: number;
}

export interface TabBarProps {
    items: TabBarItem[];
    activeKey: string | null;
    onSelect: (key: string) => void;
    className?: string;
}

/** Предел счётчика на вкладке: больше показываем как «99+» */
const BADGE_LIMIT = 99;

/**
 * Нижние вкладки мобильной версии (концепция C): иконка и подпись, активная — фирменного цвета,
 * место под счётчик. Касание не меньше 44×44, нижний отступ — под полосу жестов (safe-area).
 * Повторное нажатие на активную вкладку тоже вызывает `onSelect` — решает вызывающий код
 * (например, вернуть к корню раздела).
 */
export const TabBar = ({ items, activeKey, onSelect, className }: TabBarProps) => (
    <nav className={classnames(styles.tabbar, className)} aria-label="Разделы">
        {items.map((item) => {
            const active = item.key === activeKey;
            const badge = item.badge && item.badge > 0 ? item.badge : 0;

            return (
                <button
                    key={item.key}
                    type="button"
                    className={classnames(styles.tab, { [styles.active]: active })}
                    aria-current={active ? "page" : undefined}
                    aria-label={badge ? `${item.label}, ожидает действий: ${badge}` : item.label}
                    onClick={() => onSelect(item.key)}
                >
                    <span className={styles.icon}>
                        <GeneralIcon type={item.icon} size={24} />
                        {badge > 0 && (
                            <span className={styles.badge} aria-hidden="true">
                                {badge > BADGE_LIMIT ? `${BADGE_LIMIT}+` : badge}
                            </span>
                        )}
                    </span>
                    <span className={styles.label}>{item.label}</span>
                </button>
            );
        })}
    </nav>
);
